require('./bootstrap');
import * as coreui from '@coreui/coreui';

window.coreui = coreui;
